export default __webpack_public_path__ + "static/media/tancujeme.2c685294.svg";